import { useCallback, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../api-config';

const useProgressHandlers = ({
  soundRef,
  progress,
  setProgress,
  usuarioId,
  audiolibroId,
  currentChapterIndex,
  token,
}) => {
  const updateProgress = useCallback(() => {
    if (soundRef.current) {
      const currentProgress = soundRef.current.seek() || 0;

      if (Math.abs(currentProgress - progress) > 0.9) {
        setProgress(currentProgress);
      }

      if (soundRef.current.playing()) {
        setTimeout(updateProgress, 1000);
      }
    }
  }, [soundRef, progress, setProgress]);

  const saveProgress = useCallback(async () => {
    try {
      const currentTime = soundRef.current?.seek() || 0;
      await axios.post(
        `${API_URL}/guardar-progreso`,
        {
          usuario_id: usuarioId,
          audiolibro_id: audiolibroId,
          chapter_index: currentChapterIndex,
          progreso: currentTime,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Progreso guardado correctamente.");
    } catch (error) {
      console.error("Error al guardar el progreso:", error);
    }
  }, [soundRef, usuarioId, audiolibroId, currentChapterIndex, token]);

  const handleBeforeUnload = useCallback(() => {
    saveProgress();
  }, [saveProgress]);

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [handleBeforeUnload]);

  return {
    updateProgress,
    saveProgress,
    handleBeforeUnload,
  };
};

export default useProgressHandlers;
